

class TFReadTextModel {
    constructor() {
        this.tfReadText = "";
        this.enabled = false;
        this.selectedStyle = null

    }


    initFromJson = (obj) => {
        this.tfReadText = obj.tfReadText
        this.tfReadText = window.toAbsAllImgSrcs(this.tfReadText)
        this.enabled = obj.enabled;
        this.layout = obj.layout;
        this.selectedStyle = obj.selectedStyle

        this.styleModification()
    }


    initFromJsonTest4You=(obj) => {
        this.tfReadText = obj.tfReadText
        this.tfReadText = window.toAbsAllImgSrcs(this.tfReadText)
        this.enabled = true;
      
        // this.styleIndex = 0
        // this.selectedStyle = this.styleArr[this.styleIndex]
    }

    styleModification = () => {
        this.selectedStyle[0].style.border = "solid 0px black"
        this.selectedStyle[0].style.paddingTop = "0px"
    }



    getJsCode = () => {
        return {
            tfReadText: this.tfReadText,
            enabled: this.enabled,
            layout: this.layout
        }
    }


    getAsJson = () => {
        return {
            tfReadText: this.tfReadText,
            enabled: this.enabled,
            selectedStyle: this.selectedStyle
        }
    }

}



export default TFReadTextModel